import type { NaiveDate } from "@tento-chrono";
import type { Actor } from "../tx/invalidation.ts";
import type { CellValue } from "../core/dtype.ts";
import type { Json } from "../core/json.ts";
import type { RowLocalId } from "../ids/row-local-id.ts";
import type { Sheet } from "../sheet/sheet.ts";
import { sheetStores } from "../sheet/sheet-stores.ts";

/**
 * Write `cells` into `rowId`'s local cell store (each a `(date, value)`
 * pair; a value is a `CellValue` or wire JSON as a fixture holds it — the
 * store keeps either, as a hydrated sheet does), emitting the ordinary
 * cell-change events stamped `actor`, so formulas and renderers follow. **Local only** — nothing is persisted; for a front-end rendering an
 * offline or ephemeral sheet, fixtures and CLI replays. A user edit goes
 * through the row's own `setCell`.
 */
export function seedCells(
  sheet: Sheet,
  rowId: RowLocalId,
  cells: Iterable<readonly [NaiveDate.Partial, Json | CellValue]>,
  actor: Actor,
): void {
  const store = sheetStores(sheet).sourceCellData;
  for (const [date, value] of cells) store.set(rowId, date, value, null, null, actor);
}
